import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  loadingEmail: false,
  saveLoading: false,
  audiencesActionsLength: 0,
  audiencesActions: [],
  audiencesActionsError: "",
  emailError: "",
  formError: "",
  dataBoss: null,
};

export default function AudiencesActionsReducer(state = initialData, action) {
  switch (action.type) {
    // Cargando acciones generales
    case actions.LOADING_AUDIENCES_ACTIONS:
      return { ...state, loading: action.payload };

    // Cargando el envío de correo
    case actions.LOADING_EMAIL_SEND:
      return { ...state, loadingEmail: action.payload };

    // Cargando al guardar una acción
    case actions.SAVE_LOADING_AUDIENCES_ACTIONS:
      return { ...state, saveLoading: action.payload };

    // Obtener las audiencias
    case actions.GET_AUDIENCES_ACTIONS:
      return {
        ...state,
        audiencesActions: action.payload.audiencesActions,
        audiencesActionsLength: action.payload.audiencesActionsLength,
      };

    // Obtener los datos del jefe
    case actions.GET_DATA_BOSS:
      return { ...state, dataBoss: action.payload };

    // Limpia el store para un Jefe
    case actions.RESET_DATA_BOSS:
      return {
        ...state,
        dataBoss: null,
      };

    // Crear una audiencia
    case actions.CREATE_AUDIENCE:
      return {
        ...state,
        audiencesActions: [...state.audiencesActions, action.payload],
      };

    // Actualizar una audiencia
    case actions.UPDATE_AUDIENCE:
      return {
        ...state,
        audiencesActions: state.audiencesActions.map((audience) =>
          audience.id === action.payload.id ? action.payload : audience
        ),
      };

    // Eliminar una audiencia
    case actions.DELETE_AUDIENCE:
      return {
        ...state,
        audiencesActions: state.audiencesActions.filter(
          (audience) => audience.id !== action.payload
        ),
      };

    // Error en el formulario
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };

    // Error en las acciones de audiencias
    case actions.AUDIENCES_ACTIONS_FAIL:
      return { ...state, audiencesActionsError: action.payload };

    // Error en el envío de correo
    case actions.EMAIL_ERROR:
      return { ...state, emailError: action.payload };

    // Caso por defecto
    default:
      return state;
  }
}
